import axios from 'axios';

export default axios.create({
  // baseURL: `https://admin.metreursjaugeursassocies.com`,
  baseURL: process.env.NODE_ENV === 'development'
    ? `http://127.0.0.1:1337`
    : `https://admin.metreursjaugeursassocies.com`,
  headers: {
    'Content-Type': 'application/json',
  }
});
